import { useLocation } from 'react-router';
import { toast } from 'react-toastify';
import { toastResponse } from '../../../helper components/Toast/Toast';
import './email-verified.component.scss';

export function EmailVerified() {
  const location = useLocation();

  const resendVerification = async () => {
    let data = location.state.data;
    data = { ...data, isresend: true };

    // console.log(data);
    try {
      if (data) {
        toast.success(
          toastResponse(
            'success',
            'Email verification link was sent successfully.',
          ),
        );
      }
    } catch (error) {
      toast.error(toastResponse('error', error.data.message));
    }
  };

  return (
    <header className="site-header" id="header">
      <h1 className="fw-bolder mb-7  site-header">Verify your email</h1>
      <h4 className="fw-bolder fs-3 mb-20">
        Please visit the verification link sent to
        <br /> {location.state?.email ?? ''}
      </h4>
      <p className="text-muted fw-bold fs-4 fs-xxl-6 mb-0">
        Didn't receive an email?
        <span
          className="text-primary fw-bolder fs-4 fs-xxl-6 cursor-pointer"
          onClick={resendVerification}
        >
          {' '}
          Click here to resend
        </span>
      </p>
    </header>
  );
}
